import { render, staticRenderFns } from "./BlockTextInput.vue?vue&type=template&id=0f57a1be&"
import script from "./BlockTextInput.vue?vue&type=script&lang=js&"
export * from "./BlockTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports